import React, { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { UserCircle, KeyRound, ShieldCheck } from "lucide-react";
import { toast } from "sonner";

export default function Perfil() {
  const { user } = useAuth();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password.length < 6) return toast.error("La nueva contraseña debe tener al menos 6 caracteres");
    if (form.new_password !== form.confirm) return toast.error("Las contraseñas no coinciden");
    try {
      await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      toast.success("Contraseña actualizada");
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error");
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-6 lg:p-8 space-y-6" data-testid="perfil-page">
      <div>
        <h1 className="font-outfit font-bold text-3xl tracking-tight text-stone-900 dark:text-stone-100">Mi perfil</h1>
        <p className="text-sm text-stone-500 dark:text-stone-400 mt-1">Información de tu cuenta y cambio de contraseña.</p>
      </div>

      <Card className="p-6 border-stone-200 dark:border-stone-800 bg-white dark:bg-stone-950 shadow-sm">
        <div className="flex items-center gap-4 mb-5 pb-5 border-b border-stone-200 dark:border-stone-800">
          <div className="w-14 h-14 rounded-full bg-[#1E3A8A] text-white flex items-center justify-center text-xl font-outfit font-semibold">
            {(user?.name || "?").split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase()}
          </div>
          <div className="flex-1">
            <div className="font-outfit font-semibold text-lg text-stone-900 dark:text-stone-100">{user?.name}</div>
            <div className="text-sm text-stone-500 dark:text-stone-400">{user?.email}</div>
          </div>
          <span className={`inline-flex items-center gap-1 px-2 py-1 rounded text-[10px] uppercase tracking-wider font-outfit font-semibold ${user?.role === "dueno" ? "bg-[#1E3A8A] text-white" : "bg-stone-100 dark:bg-stone-800 text-stone-700 dark:text-stone-300"}`}>
            {user?.role === "dueno" && <ShieldCheck className="w-3 h-3" />}
            {user?.role}
          </span>
        </div>

        <div className="flex items-center gap-2 mb-3">
          <KeyRound className="w-4 h-4 text-stone-500" />
          <h2 className="font-outfit font-semibold text-stone-900 dark:text-stone-100">Cambiar contraseña</h2>
        </div>
        <form onSubmit={submit} className="space-y-3 max-w-md">
          <div><Label className="text-xs uppercase tracking-wider font-outfit font-semibold text-stone-600 dark:text-stone-400">Contraseña actual</Label><Input type="password" value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} className="mt-1" data-testid="current-password" required /></div>
          <div><Label className="text-xs uppercase tracking-wider font-outfit font-semibold text-stone-600 dark:text-stone-400">Nueva contraseña</Label><Input type="password" value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} className="mt-1" placeholder="mín. 6 caracteres" data-testid="new-password" required /></div>
          <div><Label className="text-xs uppercase tracking-wider font-outfit font-semibold text-stone-600 dark:text-stone-400">Confirmar</Label><Input type="password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} className="mt-1" data-testid="confirm-password" required /></div>
          <div className="pt-2"><Button type="submit" data-testid="change-password-submit" className="bg-[#1E3A8A] hover:bg-[#1E40AF]">Actualizar contraseña</Button></div>
        </form>
      </Card>
    </div>
  );
}
